import {
  BankSchema,
  Bank_InitialState,
  RadioSelect,
  RangeSlider,
  SearchableTextInput,
  Select,
  TextArea,
  TextInput,
  banks,
  useOptions
} from "@fla/components";
import BankIcon from "@fla/components/src/assets/svgs/bank_card.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders/consentOrdersSelectors";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: Bank_InitialState;
  onSubmit: (values: Bank_InitialState) => void;
}
const Details: FC<IProps> = ({ formId, store, onSubmit }) => {
  const { initialDetails } = useSelector(selectConsentOrdersBase);

  const { ownerV2Options, bankSplitByOptions } = useOptions({ initialDetails });

  const { handleSubmit, control, watch, setValue } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(BankSchema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b flex flex-col items-center justify-center">
        <img src={BankIcon} className="w-10 h-auto my-3" alt="bank" />
        <h3 className="font-bold">Bank Accounts</h3>
      </div>

      <SearchableTextInput
        title="Name of the financial institution?"
        control={control}
        options={banks.map((b, idx) => ({
          label: (
            <div className="flex justify-between items-center space-x-2" key={idx}>
              <p className="text-input">{b.label}</p>
              <img src={b.img} className="w-auto h-5" alt={b.img} />
            </div>
          ),
          value: b.value
        }))}
        name="name"
        id="name"
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <TextInput
        title="Current balance?"
        subTitle="If you don’t know estimate"
        control={control}
        name="value"
        id="value"
        placeholder="eg 500,000"
        isAmount
      />
      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <Select
        title="In whose name is this account in?"
        control={control}
        name="owner"
        id="owner"
        placeholder="Select"
        options={ownerV2Options}
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <TextInput title="BSB" control={control} name="bsb" id="bsb" />

      <TextInput title="Account Number" control={control} name="acc_number" id="acc_number" />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <RadioSelect
        title="What will happen to this account?"
        type="card-brief"
        id="split_by"
        name="split_by"
        control={control}
        options={bankSplitByOptions as []}
        classes="my-8"
        onChange={v => {
          if (v === "percentage") {
            setValue("percentage", { user: "50", spouse: "50" });
          }
        }}
      />

      {watch("split_by") === "percentage" ? (
        <RangeSlider
          title="Split By A Percentage"
          subTitle="Use the below slider to show the percentage you each will receive:"
          control={control}
          name="percentage.user"
          id="percentage.user"
          exName={initialDetails?.spouse?.first_name || "N/A"}
          percentageOf={watch("value")}
          onChange={val => {
            setValue("percentage.spouse", `${100 - Number(val)}`);
          }}
        />
      ) : null}

      <TextArea
        title="Further comments you want us to know about this (optional)"
        control={control}
        name="comment"
        id="comment"
        placeholder="Description"
      />
    </form>
  );
};

export default Details;
